import React from 'react';
import SignUpSelect from '../components/SignUpV2/SignUpSelect';
import { push } from '../services/routing';
import location from '../services/location';
import { parse } from '../services/queryString';
import routes from '../constants/routes';
import authService from '../services/auth';
import { SignupType } from '../model/SignupType';

export const context = 'signUp';

export class SignUpRoute extends React.PureComponent {
    state = {
        error: undefined,
        isLoading: true,
    };

    async componentDidMount() {
        const params = parse(location.search);
        if (params.new_signup === undefined) {
            push(routes.SIGN_UP_SELECTION, { new_signup: '1' });
        }
        try {
            await authService.getProfile();
            push(routes.SIGN_IN);
        } catch (error) {
            if (error.message === 'USER_NOT_LOGGED_IN') {
                this.setState({
                    isLoading: false,
                });
            } else {
                this.setState({ error: error.message });
            }
        }
    }

    render() {
        const { error } = this.state;
        if (error) {
            throw error;
        }
        const params = parse(location.search);
        return <SignUpSelect signupType={params.signupType as SignupType} />;
    }
}

export default SignUpRoute;
